import React, { useState } from 'react';
import { Card, Nav } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import TabProcessar from './components/TabProcessar';
import Tab2Via from './components/Tab2Via';

const TABS = {
  processar: 'processar',
  via2: '2via',
};

const RetornoCobrancaBradesco = () => {
  const [tabAtiva, setTabAtiva] = useState(TABS.processar);

  return (
    <>
      <Header title="Retorno Cobrança BRADESCO" />
      <div className="container-fluid mt-3">
        <Card>
          <Card.Header>
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link
                  active={tabAtiva === TABS.processar}
                  onClick={() => setTabAtiva(TABS.processar)}
                >
                  Processar Arquivo
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  active={tabAtiva === TABS.via2}
                  onClick={() => setTabAtiva(TABS.via2)}
                >
                  2ª Via
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body>
            {tabAtiva === TABS.processar && <TabProcessar />}
            {tabAtiva === TABS.via2 && <Tab2Via />}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default RetornoCobrancaBradesco;
